import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import { useLocation } from 'react-router-dom';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';

// import actions
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';

const PageData = (props) => {
  const location = useLocation();

  const data = useSelector((state) => {
    return getCurrentPageData(state, location.pathname);
  });

  const { header = {}, content = {} } = data;
  const { title, image } = header;
  const { subtitle, wysiwyg } = content;

  useEffect(() => {
    trackPageview({ title: title, path: props.path });
  }, []);

  return (
    <div className="purple-background article">
      <div className="container">
        <div className="article-header">
          <h1>{title}</h1>
          <figure>
            <img src={image} alt={title} />
          </figure>
        </div>
        <div className="article-content">
          <h2>{subtitle}</h2>
          <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: wysiwyg }}></div>
        </div>
      </div>
    </div>
  );
};

const PageArticle = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state);
  });

  return (
    <>
      <SiteMetaData {...meta} />
      <PageData props={props} />
    </>
  );
};

export default PageArticle;
